import {stringify} from 'query-string';
import config from '../../../config';
import {checkStatus, authFetch, parseHeadersAndJson} from '../../utils/http';

export default class LiveOrganisationService {
  get(organisationId, signal) {
    return authFetch(`${config.organisationApi}/api/v1/organisations/${organisationId}`, {signal})
      .then(checkStatus)
      .then(response => response.json());
  }

  getByRegistrationNumberAndCountry(registrationNumber, country, checkEnabled) {
    let queryParams = `?registrationNumber=${encodeURIComponent(registrationNumber)}&country=${country}`;
    if (checkEnabled) {
      queryParams += '&checkEnabled=true';
    }

    return authFetch(`${config.organisationApi}/api/v1/organisations${queryParams}`)
      .then(checkStatus)
      .then(response => (response.status === 204 ? null : response.json()));
  }

  search(search, page = 0, size = 10, signal = null) {
    return authFetch(`${config.organisationApi}/api/v1/organisations?${stringify({page, size})}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(search),
      signal
    })
      .then(checkStatus)
      .then(parseHeadersAndJson)
      .then(({json, headers}) => ({
        organisations: json,
        totalCount: Number(headers.get('X-Total-Count'))
      }));
  }

  createOrganisation(organisation) {
    return authFetch(`${config.organisationApi}/api/v1/organisations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(organisation)
    })
      .then(checkStatus)
      .then(response => response.json());
  }

  getDefaultOrganisation(userId, organisationId) {
    let organisationIdValue = null;
    try {
      organisationIdValue = Number.parseInt(organisationId, 10);
    } catch (error) {
      console.warn('getDefaultOrganisation, parseInt', error);
    }

    const queryParam = organisationIdValue ? `&organisationId=${organisationIdValue}` : '';
    return authFetch(`${config.organisationApi}/api/v1/organisations/default?userId=${userId}${queryParam}`)
      .then(checkStatus)
      .then(response => (response.status === 204 ? null : response.json()));
  }

  updatePriorAcceptation(organisationId, priorAcceptation) {
    return authFetch(`${config.organisationApi}/api/v1/organisations/${organisationId}/prior-acceptation`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({priorAcceptation})
    })
      .then(checkStatus);
  }

  uploadLogo(organisationId, originalFile, mediumFile) {
    const formData = new FormData();
    formData.append('originalFile', originalFile);
    formData.append('mediumFile', mediumFile);

    return authFetch(`${config.organisationApi}/api/v1/organisations/${organisationId}/logo`, {
      method: 'PATCH',
      body: formData
    })
      .then(checkStatus)
      .then(resolve => {
        sessionStorage.removeItem(`img-org-${organisationId}`);
        return resolve;
      });
  }
}
